import { mainApi } from "../services/main/api";
import { IArtifactDetails } from "./getArtifactDetailsById";

const extendedApi = mainApi.injectEndpoints({
    endpoints: builder => ({
        getArtifacts: builder.query<GetArtifactsResponse, GetArtifactsRequest>({
            query: (request: GetArtifactsRequest) => ({
                url: "getArtifacts",
                body: request,
                method: "POST",
            }),
        }),
        getComments: builder.mutation<GetArtifactsResponse, GetArtifactsRequest>({
            query: (request: GetArtifactsRequest) => ({
                url: "getArtifacts",
                body: request,
                method: "POST",
            }),
        }),
        getPropertyDetails: builder.query<GetArtifactsResponse, GetArtifactsRequest>({
            query: (request?: GetArtifactsRequest) => ({
                url: "getArtifacts",
                body: request,
                method: "POST",
            }),
        }),
        getOverdueMails: builder.query<GetArtifactsResponse, GetArtifactsRequest>({
            query: (request?: GetArtifactsRequest) => ({
                url: "getArtifacts",
                body: request,
                method: "POST",
            }),
        }),
        getFailedMails: builder.query<GetArtifactsResponse, GetArtifactsRequest>({
            query: (request?: GetArtifactsRequest) => ({
                url: "getArtifacts",
                body: request,
                method: "POST",
            }),
        }),
    }),
    overrideExisting: true,
});

export const {
    useGetArtifactsQuery,
    useGetCommentsMutation,
    useLazyGetPropertyDetailsQuery,
    useLazyGetOverdueMailsQuery,
} = extendedApi;

export interface GetArtifactsRequest {
    useCase:
        | "GET_DOCUMENTS"
        | "GET_ASSOCIATED_DOCUMENTS"
        | "GET_ASSOCIATED_PARCELS"
        | "GET_ASSOCIATED_COMMENTS"
        | "KEYWORD_SEARCH"
        | "GET_APPEALS"
        | string;
    businessUseCase: string;
    queryParams: {
        requestNumber?: number;
        limitPerRequest?: number;
        documentType?: string;
        keyword?: string;
        artifactType?: string;
        associatedArtifactId?: string;
        associatedArtifactType?:
            | "PARCEL"
            | "REAL_PROPERTY"
            | "PERSONAL_PROPERTY"
            | "DOCUMENT"
            | string;
        associatedPropertyType?: "REAL_PROPERTY" | "PERSONAL_PROPERTY" | string;
        status?: Array<StatusEnum>;
        dueDate?: string;
    };
}

export interface GetArtifactsResponse {
    data?: {
        dataList: IArtifact[];
        totalCount: number;
    };
}

export interface IArtifact {
    artifactType: string;
    useCase: string;
    updatedBy: string;
    createdBy: string;
    artifactDetailsMap: IArtifactDetails;
    artifactId: string;
    updatedOn: string;
    createdOn: string;
}

export enum StatusEnum {
    OVERDUE = "OVERDUE",
    UNREAD = "UNREAD",
    OPEN = "OPEN",
    ACTIVE = "ACTIVE",
    CLOSED = "CLOSED",
    FAILED = "FAILED",
    NEW = "NEW",
    PREPARING = "PREPARING",
    EDITING = "EDITING",
    UNDER_APPEAL = "UNDER_APPEAL",
    COMPLETE = "COMPLETE",
    NOT_APPEALED = "NOT_APPEALED",
}
